export default __webpack_public_path__ + "static/media/vf-logo-brandmark.7459d1ff.svg";